import BannerAdTracker from "../BannerAdTracker/BannerAdTracker";
import GoogleTagAdapter from "../GoogleTagAdapter/GoogleTagAdapter";
import KidsMode from "../../../commons/KidsMode/KidsMode";

export default class GooglePublisherTag {
  static setup() {
    window.googletag = window.googletag || {cmd: []};
    window.kmklabs = window.kmklabs || {};
    window.kmklabs.gpt = window.kmklabs.gpt || {};
    GooglePublisherTag.setPpid();
  }

  static setPpid() {
    GoogleTagAdapter.push(function() {
      GoogleTagAdapter.setPpid();
    });
  }

  static getTargetings(props) {
    const renameKey = (obj, oldKey, newKey) => {
      if (obj[oldKey] === undefined) {
        return obj;
      }

      delete Object.assign(obj, {[newKey]: obj[oldKey] })[oldKey];
      return obj;
    }

    props.Site = 'VIDIO';
    props = renameKey(props, 'platform', 'Platform')

    if (props.banner_embed === "true") {
      props.vidio_embed_site = GooglePublisherTag.embedSite();
    }

    Object.keys(props).forEach(key => {
      if (props[key].indexOf(',') != -1) {
        props[key] = props[key].split(',');
      }
    });

    return props;
  }

  static setTargeting(props) {
    GoogleTagAdapter.push(function () {
      GoogleTagAdapter.collapseEmptyDivs();

      if (KidsMode.isActive()) {
        GoogleTagAdapter.setChildDirectedTreatment(true);
      }

      let targetings = GooglePublisherTag.getTargetings(props);
      for (const [key, value] of Object.entries(targetings)) {
        if (!!value) {
          GoogleTagAdapter.setTargeting(key, value);
        }
      }
    });
  }

  static setCompanionAds() {
    GoogleTagAdapter.companionAds().setRefreshUnfilledSlots(false);
    GoogleTagAdapter.enableVideoAds();
  }

  static shouldRefresh(element, desktop) {
    if (!element) {
      return false;
    }

    let thresholdTop = 0;
    if (desktop) {
      thresholdTop =
        document.querySelector(".site-header").offsetHeight / 2 + 1;
    }

    const isElementSeen = (el) => {
      return document.visibilityState === "visible" && document.fullscreenElement == null && el.getBoundingClientRect().top >= thresholdTop
    }
    
    const leaderboardPlaceholder = document.querySelector('.leaderboard_placeholder')
    if(element.id === 'leaderboard' && leaderboardPlaceholder && isElementSeen(leaderboardPlaceholder)) {
      return true;
    }

    return isElementSeen(element);
  }

  static refreshAdSlot(slot, id, desktop = false, interval = 60) {
    if (interval < 1) {
      return;
    }

    if (interval < 60) {
      interval = 60;
    }

    return setInterval(function () {
      const el = document.getElementById(id);
      if (GooglePublisherTag.shouldRefresh(el, desktop)) {
        GoogleTagAdapter.push(function () {
          GoogleTagAdapter.refresh([slot]);
        });
      }
    }, interval * 1000);
  }

  static constructAdProps(adSlot, adUuid, event) {
    var props = {};
    props.ad_slot = adSlot;
    props.ad_uuid = adUuid;
    props.advertiser_id = event.advertiserId;
    props.campaign_id = event.campaignId;
    props.creative_id = event.creativeId;
    props.is_empty = event.isEmpty;
    props.line_item_id = event.lineItemId;
    props.size = event.size;
    props.source_agnostic_creative_id = event.sourceAgnosticCreativeId;
    props.source_agnostic_line_item_id = event.sourceAgnosticLineItemId;
    return props;
  }

  static displayLeaderboardAd(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var ad_name = "leaderboard";
      var parsed_ad_size = JSON.parse(ad_size);

      GooglePublisherTag.trackSlotRenderEnded(ad_name);
      GooglePublisherTag.trackImpressionViewable(ad_name);

      window.kmklabs.gpt.leaderboard = GoogleTagAdapter.defineSlotWithCompanionAds(
        ad_slot,
        parsed_ad_size,
        ad_name
      );

      GooglePublisherTag.setCompanionAds();
      GooglePublisherTag.display(window.kmklabs.gpt.leaderboard);
    });
  }

  static setPauseAd(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var parsed_ad_size = JSON.parse(ad_size);

      GooglePublisherTag.trackSlotRenderEndedPause();
      GooglePublisherTag.trackImpressionViewablePause();

      window.kmklabs.gpt.pause_ads = GoogleTagAdapter.defineSlot(
        ad_slot,
        parsed_ad_size,
        "pause_ads"
      ).setTargeting("user_login", `${window.isUserSignedIn}`);
    });
  }

  static setOverlayAd(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      GooglePublisherTag.adjustUIOverlay();

      GooglePublisherTag.trackSlotRenderEndedOverlay();
      GooglePublisherTag.trackImpressionViewableOverlay();

      var parsed_ad_size = JSON.parse(ad_size);
      window.kmklabs.gpt.overlay_ad = GoogleTagAdapter.defineSlot(
        ad_slot,
        parsed_ad_size,
        "overlay_ad"
      );
    });
  }

  static displayTopBannerAd(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var ad_name = "top_banner";
      var parsed_ad_size = JSON.parse(ad_size);

      GooglePublisherTag.adjustUITopBanner();
      GooglePublisherTag.trackSlotRenderEnded(ad_name);
      GooglePublisherTag.trackImpressionViewable(ad_name);

      window.kmklabs.gpt.top_banner = GoogleTagAdapter.defineSlotWithCompanionAds(
        ad_slot,
        parsed_ad_size,
        ad_name
      );

      GooglePublisherTag.setCompanionAds();
      GooglePublisherTag.display(window.kmklabs.gpt.top_banner);
    });
  }

  static displayMiddleBannerAd(adUnit, adSize, adSlot = "middle_banner") {
    GoogleTagAdapter.push(function () {
      const parsedAdSize = JSON.parse(adSize);
      GooglePublisherTag.adjustUIMiddleBanner(adSlot);
      GooglePublisherTag.trackSlotRenderEnded(adSlot);
      GooglePublisherTag.trackImpressionViewable(adSlot);

      const slot = GoogleTagAdapter.defineSlot(adUnit, parsedAdSize, adSlot)

      GooglePublisherTag.display(slot);
    });
  }

  static displayBannerSectionAd(sourceId, adUnit, adSize, containerId) {
    GoogleTagAdapter.push(function () {
      GooglePublisherTag.adjustUISectionBanner();
      GooglePublisherTag.trackSlotRenderEnded(containerId);
      GooglePublisherTag.trackImpressionViewable(containerId);

      window.kmklabs.gpt['section_' + sourceId] = GoogleTagAdapter.defineSlot(
        adUnit,
        adSize,
        containerId
      );

      GooglePublisherTag.display(window.kmklabs.gpt['section_' + sourceId]);
    });
  }

  static displaySkyscraperAd(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var ad_name = "skyscraper";

      GooglePublisherTag.trackSlotRenderEnded(ad_name);
      GooglePublisherTag.trackImpressionViewable(ad_name);

      window.kmklabs.gpt.skyscraper = GoogleTagAdapter.defineSlot(
        ad_slot,
        ad_size,
        ad_name
      );

      GooglePublisherTag.display(window.kmklabs.gpt.skyscraper);
    });
  }

  static displayNativeAd(adUnit, adSlot = "native_stream") {
    GoogleTagAdapter.push(function () {
      const slot = GoogleTagAdapter.defineSlot(adUnit, ['fluid', [1, 1]], adSlot)
      GooglePublisherTag.trackSlotRenderEnded(adSlot);
      GooglePublisherTag.trackImpressionViewable(adSlot);
      GooglePublisherTag.display(slot);
    })
  }

  static isEventSlotType(slotName, event) {
    try {
      return !event.isEmpty && event.slot.getSlotId().getDomId() == slotName;
    } catch {
      return false;
    }
  }

  static adjustUIOverlay() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType("overlay_ad", event)) {
        const width = event.size[0];
        const height = event.size[1];
        window.player.ads().overlay().showOverlayAd(width, height);
      }
    });
  }

  static adjustUITopBanner() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType("top_banner", event)) {
        document.querySelector("#top_banner").style.textAlign =
          "-webkit-center";
      }
    });
  }

  static adjustUIMiddleBanner(adSlot) {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType(adSlot, event)) {
        const sectionElement = document.querySelector(`#${adSlot}`).closest('section');
        sectionElement.style.display = 'flex';
      }
    });
  }

  static adjustUISectionBanner() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType("banner-gam", event)) {
        const sectionElement = document.querySelector(`#banner-gam`).closest('section > div');
        sectionElement.style.display = 'block';
      }
    });
  }

  static getOffsetHeight(element) {
    return element.offsetHeight;
  }

  static trackSlotRenderEnded(ad_name) {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (event.slot.getSlotId().getDomId() == ad_name) {
        var ad_uuid = BannerAdTracker.uuid();

        if (event.isEmpty) {
          BannerAdTracker.sendAdEventEmpty(ad_name, ad_uuid);
        } else {
          var props = GooglePublisherTag.constructAdProps(
            ad_name,
            ad_uuid,
            event
          );
          BannerAdTracker.sendAdEventStart(props);

          var ad_unit = event.slot.getAdUnitPath();
          GooglePublisherTag.setAdUnitUUIDandSlot(ad_unit, ad_uuid, ad_name)
        }
      }
    });
  }

  static trackImpressionViewable(ad_name) {
    GoogleTagAdapter.addEventListener("impressionViewable", function (event) {
      if (event.slot.getSlotId().getDomId() == ad_name) {
        const ad_unit = event.slot.getAdUnitPath();
        const ad_uuid = window.kmklabs.gpt.ad_unit?.[`${ad_unit}`];
        if (ad_uuid === undefined) return;
        BannerAdTracker.sendAdEventImpressionViewable(ad_name, ad_uuid);
      }
    });
  }

  static trackSlotRenderEndedPause() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (event.slot.getSlotId().getDomId() == "pause_ads") {
        var ad_uuid = BannerAdTracker.uuid();

        var props = GooglePublisherTag.constructAdProps("pause_ads", ad_uuid, event);
        if (event.isEmpty) {
          window.player.ads().pauseAdvertisement().sendEmptyEvent(props);
        } else {
          window.player.ads().pauseAdvertisement().sendStartEvent(props);

          var ad_unit = event.slot.getAdUnitPath();
          GooglePublisherTag.setAdUnitUUIDandSlot(ad_unit, ad_uuid, "pause_ads")
        }
      }
    });
  }

  static trackImpressionViewablePause() {
    GoogleTagAdapter.addEventListener("impressionViewable", function (event) {
      if (event.slot.getSlotId().getDomId() == "pause_ads") {
        var ad_unit = event.slot.getAdUnitPath();
        var ad_uuid = window.kmklabs.gpt.ad_unit[`${ad_unit}`];
        var props = { ad_uuid: ad_uuid };
        window.player.ads().pauseAdvertisement().sendImpressionEvent(props);
      }
    });
  }

  static trackSlotRenderEndedOverlay() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (event.slot.getSlotId().getDomId() == "overlay_ad") {
        var ad_uuid = BannerAdTracker.uuid();

        var props = GooglePublisherTag.constructAdProps("overlay", ad_uuid, event);
        if (event.isEmpty) {
          window.player.ads().overlay().sendEmptyEvent(props);
        } else {
          window.player.ads().overlay().sendStartEvent(props);

          var ad_unit = event.slot.getAdUnitPath();
          GooglePublisherTag.setAdUnitUUIDandSlot(ad_unit, ad_uuid, "overlay")
        }
      }
    });
  }
  static trackImpressionViewableOverlay() {
    GoogleTagAdapter.addEventListener("impressionViewable", function (event) {
      if (event.slot.getSlotId().getDomId() == "overlay_ad") {
        var ad_unit = event.slot.getAdUnitPath();
        var ad_uuid = window.kmklabs.gpt.ad_unit[`${ad_unit}`];
        var props = { ad_uuid: ad_uuid };
        window.player.ads().overlay().sendImpressionEvent(props);
      }
    });
  }

  static setAdUnitUUIDandSlot(ad_unit, ad_uuid, ad_slot) {
    window.kmklabs.gpt.ad_unit = window.kmklabs.gpt.ad_unit || {};
    window.kmklabs.gpt.ad_unit[`${ad_unit}`] = {
      ad_uuid: ad_uuid,
      ad_slot: ad_slot,
    };
  }

  static enableLazyLoad(options) {
    GoogleTagAdapter.push(function () {
      GoogleTagAdapter.enableLazyLoad(options);
    });
  }

  static enableServices() {
    GoogleTagAdapter.push(function () {
      window.googletag.enableServices();
    });
  }

  static display(slotOrDivName) {
    GoogleTagAdapter.push(() => {
      GoogleTagAdapter.display(slotOrDivName);
    });
  }

  static embedSite() {
    const hostname = this.referrer().match(
      /^(?:https?:\/\/)?(?:[^@\n]+@)?([^:\/\n]+)/im
    );
    if (hostname === null) {
      return "null";
    }
    return hostname[1];
  }

  static referrer() {
    return document.referrer;
  }
}
